export default __webpack_public_path__ + "static/media/logout_white_48dp.19848752.svg";